(ns frontend.view.modals.folder-management-modal.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.view.modals.folder-management-modal.event :as event]
   [frontend.view.modals.folder-management-modal.sub :as sub]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(def modal-key ::modal-key)

(defn folder-tree
  []
  (let [temp-list @(rf/subscribe [::sub/temp-list])]
    [:div
     #_[:ul                                                                                         ;; DEBUG
        (->> temp-list
             (map (fn [l]
                    [:li (pr-str l)]))
             )]
     [:ul
      {:class "flex flex-col gap-2"}
      (->> temp-list
           (remove (fn [{:keys [status]}]
                     (= status :removed)))
           (map (fn [{:keys [folder-name] :as item}]
                  [:li
                   {:class "flex items-center gap-3"}
                   [:i.fas.fa-folder
                    {:class "text-base-light-text-paler"}]
                   [data-input/view
                    {:class     "flex-1"
                     :data-type :data.type/text-simple
                     :value     folder-name
                     :on-change #(rf/dispatch [::event/edit-folder-name item %])}]
                   [button/square-secondary-open
                    {:tooltip    (loc/tr :folder-management/remove-folder)
                     :aria-label (loc/tr :folder-management/remove-folder)
                     :on-click   #(rf/dispatch [::event/remove-folder-name item])}
                    [:i.fal.fa-trash-alt]]]
                  )))]
     [:div
      {:class "py-2 px-6"}
      [button/secondary-open
       {:on-click #(rf/dispatch [::event/add-folder])}
       [:i.fal.fa-plus]
       (loc/tr :add-folder)]]
     ]))

(defn view
  [{:keys [_shown? close-modal! props _topmost?]}]
  (let [{:keys [entity]} props
        on-close! (fn []
                    (rf/dispatch [::event/clear])
                    (close-modal!))]
    (rf/dispatch [::event/init entity])
    (fn [{:keys [shown? props topmost?]}]
      (let [{:keys [entity]} props
            changes? @(rf/subscribe [::sub/changes?])]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         on-close!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :manage-folders-for [(entity/display-string entity)])
         [folder-tree]
         [:<>
          [modal/left-cancel-only on-close! nil]
          [modal/right-single-button
           ::c/primary
           (not changes?)
           #(rf/dispatch [::event/save! entity on-close!])
           (loc/tr :save)
           nil]]]))))
